import type { ControllerFieldState, FieldError } from "react-hook-form";

export const validationError = (
  fieldState: ControllerFieldState,
  submitted: boolean,
): FieldError | undefined => {
  if (!fieldState.error) return undefined;

  return submitted || fieldState.isTouched ? fieldState.error : undefined;
};
